import script from "./ClinicalTimelineCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ClinicalTimelineCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__